import React from 'react'
import {Button, FormControl, FormGroup, TextField} from '@mui/material';
import { Typography,Select } from '@mui/material'
import PassengerImg from '../assets/images/IconsNew/age-group.png'
import { Controller } from "react-hook-form";
import styled from '@emotion/styled';

const SearchBox = styled(TextField)(() => ({
	'& input': {
	  paddingLeft: '4px',
	  height: '15px',
	  paddingLeft: 2
	},
	'& fieldset': {
	  borderRadius: '4px',
	},
  }));
const SelectPassenger = ({fieldName,fieldLabel,width,fontSize,control,children, open, onOpen, onClose, values}) => {
    return (
        <FormGroup  style={{ marginRight: 5, marginLeft: 5,  marginBottom: 1 }} >
            <Typography className='formText' sx={{ fontSize: '12px' }}  >{fieldLabel}</Typography>
            <FormControl fullWidth>
                <Controller
                    name={fieldName}
                    control={control ? control : null}
                    render={({ field }) =><Select 
                        labelId="level-label" 
                        {...field} 
                        open={open}
                        onOpen={onOpen}
                        onClose={onClose}
                        disableUnderline
                        style={{ backgroundColor: '#fff',   borderRadius: 4, border: '1px solid #ccc', width: '100%', height: 26, justifyContent: 'center' }}
                        variant="standard"  className='formText'
                        //components={<SearchBox />}
                        //input={<SearchBox />}
                        IconComponent={() => (
                            <Button variant='text' style={{ padding: 0, width: 20, margin: 0 }}>
                            <img src={PassengerImg} width='20' height='20' onClick={onOpen}  />
                            </Button>
                        )}
                    >
                        {children}
                    </Select>}
                />
                <Typography className='formText' style={{ position: 'absolute', top: 7, left: 10 }}  >{values}</Typography>
            </FormControl>
        </FormGroup>
    )
}

export default SelectPassenger
